
<button class="{{ctrlClasses}}" [disabled]="isDisabled" type="submit" [ngClass]="{&quot;b-button b-button--new_design&quot;: !withoutBtnClasses}">
  <ng-content></ng-content>
</button>